import { Serializable } from "../utilities/Serializable";
import { PosType } from "./PosType";
import { Zone } from "./Zone";

export class PoS extends Serializable {
    uuid: string;
    name: string;
    code: string;
    icon: string;
    zone: Zone;
    type: PosType;
}


// WEBPACK FOOTER //
// ./src/app/models/PoS.ts